<template>
  <div class="page-menu">
    <div class="menuDome">
      <el-menu
        :default-active="activeRouterIndex"
        v-for="(item, index) in menuList"
        :key="index"
        router
        unique-opened
        :default-openeds="defaultOpenedList"
        @open="openMenu"
        @select="selectMenu"
        active-text-color="#2e68ea"
        class="el-menu-vertical-demo"
      >
        <el-menu-item
          :index="item.url"
          v-show="!item.children || item.children.length === 0"
        >
          <span slot="title">
            <div class="menu-title">
              <p class="menu-left">
                <svg
                  v-if="item.url === '/base-info'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="8051"
                  width="18"
                  height="18"
                >
                  <path
                    d="M861.090909 954.181818H162.909091c-51.2 0-93.090909-41.890909-93.090909-93.090909V535.272727h884.363636v325.818182c0 51.2-41.890909 93.090909-93.090909 93.090909zM116.363636 209.454545h791.272728c25.6 0 46.545455 20.945455 46.545454 46.545455v186.181818H69.818182v-186.181818c0-25.6 20.945455-46.545455 46.545454-46.545455zM279.272727 116.363636v93.090909h116.363637V165.236364h232.727272V209.454545h116.363637V116.363636c0-25.6-20.945455-46.545455-46.545455-46.545454H325.818182c-25.6 0-46.545455 20.945455-46.545455 46.545454z"
                    p-id="8052"
                    fill="#2E68EA"
                  />
                </svg>
                <svg
                  v-if="item.url === '/service'"
                  t="1647592918802"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2732"
                  width="18"
                  height="18"
                >
                  <path
                    d="M860.7 349.9c13.3 1.5 26.1 4.9 39.4 10.3s24.6 13.3 33.9 23.1c9.8 9.8 16.7 22.6 21.6 37.9 4.9 15.3 5.4 33 2 54.1v1c-1.5 5.9-3.9 19.2-8.4 40.3-3.9 21.6-8.9 46.7-14.3 74.8-5.4 28-11.8 57.1-18.7 87.1-6.9 30-13.3 55.6-19.7 76.8-3.4 12.3-8.4 25.1-14.8 38.4-6.4 13.3-14.8 25.1-25.1 35.4-10.3 10.8-22.6 19.7-37.4 26.6-14.3 6.9-31.5 10.3-51.7 10.3H196c-14.3 0-29.5-3-44.8-9.3-15.3-6.4-30-14.8-42.8-26.6s-23.6-25.1-32-41.3c-8.4-16.2-12.3-34.4-12.3-54.1V291.8c0-41.8 11.3-74.8 33.9-98.4s54.7-35.4 96-35.4h507.7c15.3 0 31 3 46.7 8.9 16.2 5.9 31 13.8 43.8 24.1 13.3 10.3 23.6 22.1 32 35.9s12.3 28.5 12.3 44.3c0 6.4-4.9 11.3-11.3 11.3H783c-27.6 0-59.5 0-96.4-0.5s-76.3-0.5-117.6-0.5-80.7 0-116.6-0.5c-35.9-0.5-67.4-0.5-93.5-0.5h-47.7c-17.7 0-32 5.9-41.8 17.2-9.8 11.3-17.7 26.6-23.1 44.8-5.4 20.2-11.8 41.3-18.7 63.5s-13.3 43.3-18.7 62.5c-6.9 22.6-13.8 44.3-20.7 65.4 0 0.5 0 0.5-0.5 1-1.5 5.4-2 9.8-2 12.8 0 11.8 3.9 21.6 11.8 29.5 7.9 7.9 17.7 11.8 29.5 11.8 21.2 0 35.9-13.3 43.3-40.3l52.6-191.9c1.5-4.9 5.9-8.4 11.3-8.4 86.1 0.5 164.8 1 237.1 1l289.4 0.5z"
                    p-id="2733"
                    fill="#2e68ea"
                  ></path>
                </svg>
                <svg
                  v-if="item.url === '/attendance'"
                  t="1647592615543"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3683"
                  width="18"
                  height="18"
                >
                  <path
                    d="M118.6816 482.7136v314.368c0 69.3248 56.1664 125.4912 125.4912 125.4912H774.656c69.3248 0 125.4912-56.1664 125.4912-125.4912v-314.368H118.6816zM481.28 635.2896H290.1504c-16.9472 0-30.72-13.7728-30.72-30.72s13.7728-30.72 30.72-30.72H481.28c16.9472 0 30.72 13.7728 30.72 30.72s-13.7728 30.72-30.72 30.72zM303.0016 296.3968c-16.9472 0-30.72-13.7728-30.72-30.72V157.184c0-16.9472 13.7728-30.72 30.72-30.72s30.72 13.7728 30.72 30.72v108.4928c0 16.9984-13.7728 30.72-30.72 30.72zM720.4352 296.3968c-16.9472 0-30.72-13.7728-30.72-30.72V157.184c0-16.9472 13.7728-30.72 30.72-30.72s30.72 13.7728 30.72 30.72v108.4928c0 16.9984-13.7728 30.72-30.72 30.72z"
                    fill="#2e68ea"
                    p-id="3684"
                  ></path>
                  <path
                    d="M784.4352 182.4256v83.2512c0 35.2768-28.7232 64-64 64s-64-28.7232-64-64V182.016H367.0016v83.6608c0 35.2768-28.7232 64-64 64s-64-28.7232-64-64V182.1696c-66.9184 2.7136-120.32 57.8048-120.32 125.3888v112.4352h781.5168V307.5072c0-65.9968-50.9952-120.064-115.7632-125.0816z"
                    fill="#2e68ea"
                    p-id="3685"
                  ></path>
                </svg>
                <svg
                  v-if="item.url === '/project-manage'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="8051"
                  width="18"
                  height="18"
                >
                  <path
                    d="M861.090909 954.181818H162.909091c-51.2 0-93.090909-41.890909-93.090909-93.090909V535.272727h884.363636v325.818182c0 51.2-41.890909 93.090909-93.090909 93.090909zM116.363636 209.454545h791.272728c25.6 0 46.545455 20.945455 46.545454 46.545455v186.181818H69.818182v-186.181818c0-25.6 20.945455-46.545455 46.545454-46.545455zM279.272727 116.363636v93.090909h116.363637V165.236364h232.727272V209.454545h116.363637V116.363636c0-25.6-20.945455-46.545455-46.545455-46.545454H325.818182c-25.6 0-46.545455 20.945455-46.545455 46.545454z"
                    p-id="8052"
                    fill="#2E68EA"
                  />
                </svg>
                <svg
                  v-if="item.url === '/carrier'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="8277"
                  width="18"
                  height="18"
                >
                  <path
                    d="M176.872727 900.654545c-65.163636 0-116.363636-51.2-116.363636-116.363636s51.2-116.363636 116.363636-116.363636 116.363636 51.2 116.363637 116.363636-51.2 116.363636-116.363637 116.363636zM828.509091 900.654545c-65.163636 0-116.363636-51.2-116.363636-116.363636s51.2-116.363636 116.363636-116.363636 116.363636 51.2 116.363636 116.363636-51.2 116.363636-116.363636 116.363636z"
                    p-id="8278"
                    fill="#2E68EA"
                  />
                  <path
                    d="M1003.054545 558.545455H698.181818v235.054545h258.327273c25.6 0 46.545455-20.945455 46.545454-46.545455V558.545455z"
                    p-id="8279"
                    fill="#2E68EA"
                  />
                  <path
                    d="M842.472727 374.690909H698.181818v48.872727h130.327273c13.963636 0 25.6 6.981818 34.909091 18.618182l83.781818 118.690909h55.854545l-128-167.563636c-9.309091-11.636364-20.945455-18.618182-32.581818-18.618182zM698.181818 793.6H46.545455c-25.6 0-46.545455-20.945455-46.545455-46.545455v-558.545454c0-51.2 41.890909-93.090909 93.090909-93.090909h512c51.2 0 93.090909 41.890909 93.090909 93.090909v605.090909z"
                    p-id="8280"
                    fill="#2E68EA"
                  />
                </svg>
                <svg
                  v-if="item.url === '/cost'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="8958"
                  width="18"
                  height="18"
                >
                  <path
                    d="M104.727273 786.618182l344.436363 148.945454c41.890909 18.618182 93.090909 18.618182 134.981819 0l344.436363-148.945454c18.618182-6.981818 27.927273-25.6 27.927273-44.218182 0-18.618182-11.636364-37.236364-27.927273-44.218182l-53.527273-23.272727c-23.272727-9.309091-48.872727-9.309091-72.145454 0l-186.181818 81.454545c-23.272727 9.309091-46.545455 18.618182-72.145455 18.618182-39.563636 4.654545-81.454545-2.327273-118.690909-18.618182L230.4 674.909091c-23.272727-9.309091-48.872727-9.309091-72.145455 0l-53.527272 23.272727c-39.563636 16.290909-39.563636 69.818182 0 88.436364z m0-470.109091L449.163636 465.454545c41.890909 18.618182 93.090909 18.618182 134.981819 0l344.436363-148.945454c18.618182-6.981818 27.927273-25.6 27.927273-44.218182 0-18.618182-11.636364-37.236364-27.927273-44.218182L584.145455 81.454545c-41.890909-18.618182-93.090909-18.618182-134.981819 0L104.727273 228.072727c-39.563636 16.290909-39.563636 72.145455 0 88.436364z m0 0"
                    p-id="8959"
                    fill="#2E68EA"
                  />
                  <path
                    d="M104.727273 549.236364L449.163636 698.181818c41.890909 18.618182 93.090909 18.618182 134.981819 0l344.436363-148.945454c16.290909-6.981818 27.927273-25.6 27.927273-44.218182 0-18.618182-11.636364-34.909091-27.927273-44.218182l-53.527273-23.272727c-23.272727-9.309091-48.872727-9.309091-72.145454 0l-186.181818 81.454545c-23.272727 9.309091-46.545455 18.618182-72.145455 18.618182-39.563636 4.654545-81.454545-2.327273-118.690909-18.618182l-190.836364-81.454545c-23.272727-9.309091-48.872727-9.309091-72.145454 0l-53.527273 23.272727c-18.618182 6.981818-27.927273 25.6-27.927273 44.218182-6.981818 20.945455 4.654545 37.236364 23.272728 44.218182z m0 0"
                    p-id="8960"
                    fill="#2E68EA"
                  />
                </svg>
                <svg
                  v-if="item.url === '/warehouse-manage'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="1134"
                  width="18"
                  height="18"
                >
                  <path
                    d="M202.472727 62.836364H837.818182c23.272727 0 46.545455 16.290909 53.527273 39.563636l72.145454 237.381818h-884.363636l69.818182-237.381818c6.981818-25.6 27.927273-39.563636 53.527272-39.563636z m758.690909 330.472727v498.036364c0 13.963636-6.981818 27.927273-16.290909 39.563636-9.309091 9.309091-23.272727 16.290909-39.563636 16.290909H132.654545c-13.963636 0-27.927273-6.981818-39.563636-16.290909-9.309091-9.309091-16.290909-23.272727-16.290909-39.563636V393.309091h884.363636zM698.181818 614.4H339.781818c-13.963636 0-27.927273 6.981818-34.909091 20.945455-6.981818 13.963636-6.981818 27.927273 0 41.890909 6.981818 13.963636 20.945455 20.945455 34.909091 20.945454H698.181818c13.963636 0 27.927273-6.981818 34.909091-20.945454 6.981818-13.963636 6.981818-27.927273 0-41.890909-4.654545-11.636364-18.618182-20.945455-34.909091-20.945455z m0 0"
                    p-id="1135"
                    fill="#2E68EA"
                  />
                </svg>
                <svg
                  v-if="item.url === '/system-settings'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="1172"
                  width="18"
                  height="18"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <path
                    d="M781.473684 476.968421c-29.642105 0-56.589474 16.168421-70.063158 40.421053s-13.473684 56.589474 0 80.842105c13.473684 24.252632 40.421053 40.421053 70.063158 40.421053 45.810526 0 80.842105-35.031579 80.842105-80.842106 0-43.115789-37.726316-80.842105-80.842105-80.842105z"
                    p-id="1173"
                    fill="#2E68EA"
                  />
                  <path
                    d="M916.210526 0H107.789474C48.505263 0 0 48.505263 0 107.789474v808.421052c0 59.284211 48.505263 107.789474 107.789474 107.789474h808.421052c59.284211 0 107.789474-48.505263 107.789474-107.789474V107.789474c0-59.284211-48.505263-107.789474-107.789474-107.789474zM557.810526 773.389474H97.010526v-21.557895c0-26.947368 18.863158-56.589474 43.11579-67.368421l132.042105-61.978947s8.084211-2.694737 8.084211-16.168422v-18.863157c0-18.863158-48.505263-37.726316-56.589474-97.010527-2.694737-26.947368-5.389474-80.842105-5.389474-86.231579 0-51.2 53.894737-94.315789 110.484211-94.315789 56.589474 0 110.484211 40.421053 110.48421 94.315789 0 2.694737 0 59.284211-5.389473 86.231579-8.084211 59.284211-56.589474 80.842105-56.589474 97.010527v18.863157c0 10.778947 8.084211 16.168421 8.08421 16.168422l132.042106 61.978947c24.252632 10.778947 43.115789 40.421053 43.115789 67.368421v21.557895zM943.157895 590.147368s-37.726316 8.084211-40.421053 13.473685c-2.694737 2.694737-2.694737 8.084211-5.389474 10.778947 5.389474 8.084211 29.642105 24.252632 29.642106 24.252632l-61.978948 64.673684s-24.252632-24.252632-29.642105-26.947369c-5.389474 2.694737-8.084211 2.694737-13.473684 5.389474s-8.084211 37.726316-8.084211 37.726316h-64.673684s-5.389474-37.726316-10.778947-40.421053c-2.694737 0-5.389474-2.694737-10.778948-2.694737-5.389474 2.694737-45.810526 26.947368-45.810526 26.947369l-48.505263-64.673684s21.557895-16.168421 29.642105-26.947369c-2.694737-2.694737-2.694737-8.084211-5.389474-10.778947-5.389474-5.389474-40.421053-13.473684-40.421052-13.473684v-64.673685l40.421052-8.08421c0-2.694737 2.694737-5.389474 2.694737-8.084211-2.694737-8.084211-24.252632-32.336842-24.252631-32.336842l48.505263-64.673684s29.642105 26.947368 37.726316 29.642105c2.694737-2.694737 8.084211-2.694737 10.778947-2.694737 10.778947-2.694737 16.168421-43.115789 16.168421-43.115789h64.673684s10.778947 40.421053 16.168421 40.421053c2.694737 0 8.084211 2.694737 10.778948 2.694736 8.084211-2.694737 37.726316-29.642105 37.726316-29.642105l48.505263 61.978948s-24.252632 18.863158-29.642106 29.642105c0 2.694737 2.694737 5.389474 2.694737 8.08421 0 2.694737 43.115789 10.778947 43.11579 10.778948v72.757894z"
                    p-id="1174"
                    fill="#2E68EA"
                  />
                </svg>
                <svg
                  v-if="item.url === '/finance'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="1529"
                  width="18"
                  height="18"
                >
                  <path
                    d="M959.359 854.226c0 12.485-2.133 24.14-6.404 34.98-4.271 10.84-10.347 20.364-18.227 28.577-7.884 8.214-17.085 14.618-27.595 19.213-10.506 4.6-22.004 6.898-34.488 6.898h-715.38c-12.48 0-24.306-2.298-35.475-6.898-11.164-4.595-21.017-10.999-29.558-19.213-8.543-8.214-15.276-17.738-20.2-28.576-4.93-10.84-7.391-22.497-7.391-34.981V362.523c0-24.96 8.701-46.145 26.11-63.554 17.409-17.408 38.595-26.115 63.559-26.115h715.38c24.964 0 46.15 8.707 63.559 26.115 17.409 17.41 26.11 38.595 26.11 63.554v134.014H735.681c-24.965 0-46.15 8.538-63.56 25.617-17.408 17.08-26.11 38.101-26.11 63.065 0.66 17.08 4.272 32.19 10.841 45.328 5.253 11.17 13.96 21.35 26.11 30.545 12.155 9.196 29.729 13.796 52.719 13.796h223.678v179.338z m-134.01-626.7H377.99c35.474-18.39 68.976-36.127 100.507-53.206a9304.123 9304.123 0 0 0 81.79-43.36c26.932-14.448 47.954-25.617 63.064-33.502 22.99-12.48 43.519-18.23 61.586-17.244 18.062 0.986 33.337 4.106 45.816 9.36 14.454 7.226 26.937 16.75 37.449 28.577l57.148 109.376zM691.34 585.22c0-12.48 4.27-22.99 12.808-31.533 8.544-8.538 19.054-12.808 31.534-12.808 12.479 0 22.99 4.27 31.533 12.808 8.538 8.542 12.808 19.054 12.808 31.533s-4.27 23.155-12.808 32.026c-8.544 8.865-19.054 13.302-31.533 13.302-12.48 0-22.99-4.436-31.534-13.302-8.538-8.871-12.808-19.546-12.808-32.026z m0 0"
                    fill="#2E68EA"
                    p-id="1530"
                  ></path>
                </svg>
                <svg
                  v-if="item.url === '/home'"
                  t="1587365559285"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="7552"
                  width="18"
                  height="18"
                >
                  <path
                    d="M453.818182 88.436364L95.418182 302.545455c-23.272727 13.963636-39.563636 41.890909-39.563637 69.818181v498.036364c0 44.218182 34.909091 81.454545 81.454546 81.454545h230.4v-200.145454c0-23.272727 18.618182-39.563636 39.563636-39.563636h160.581818c23.272727 0 39.563636 18.618182 39.563637 39.563636v200.145454H861.090909c44.218182 0 81.454545-34.909091 81.454546-81.454545V370.036364c0-27.927273-16.290909-55.854545-39.563637-69.818182L535.272727 88.436364c-25.6-13.963636-55.854545-13.963636-81.454545 0z"
                    p-id="7553"
                    fill="#2E68EA"
                  />
                </svg>
                <svg
                  v-if="item.url === '/employee'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="1042"
                  width="18"
                  height="18"
                >
                  <path
                    d="M851.781818 69.818182h-698.181818c-51.2 0-93.090909 41.890909-93.090909 93.090909v698.181818c0 51.2 41.890909 93.090909 93.090909 93.090909h698.181818c51.2 0 93.090909-41.890909 93.090909-93.090909V162.909091c0-51.2-41.890909-93.090909-93.090909-93.090909zM539.927273 737.745455H141.963636v-18.618182c0-23.272727 16.290909-48.872727 37.236364-58.181818l114.036364-53.527273s6.981818-2.327273 6.981818-13.963637v-16.290909c0-16.290909-41.890909-32.581818-48.872727-83.781818-2.327273-23.272727-4.654545-69.818182-4.654546-74.472727 0-44.218182 46.545455-81.454545 95.418182-81.454546 48.872727 0 95.418182 34.909091 95.418182 81.454546 0 2.327273 0 51.2-4.654546 74.472727-6.981818 51.2-48.872727 69.818182-48.872727 83.781818v16.290909c0 9.309091 6.981818 13.963636 6.981818 13.963637l114.036364 53.527273c20.945455 9.309091 37.236364 34.909091 37.236363 58.181818v18.618182z m293.236363 4.654545h-130.327272c-23.272727 0-44.218182-18.618182-44.218182-41.890909s18.618182-44.218182 44.218182-41.890909h130.327272c23.272727 0 44.218182 18.618182 44.218182 41.890909-2.327273 23.272727-20.945455 41.890909-44.218182 41.890909z m0-172.218182h-130.327272c-23.272727 0-44.218182-18.618182-44.218182-41.890909 0-11.636364 4.654545-23.272727 11.636363-30.254545 6.981818-6.981818 18.618182-11.636364 30.254546-11.636364h130.327273c11.636364 0 23.272727 4.654545 30.254545 11.636364 6.981818 6.981818 11.636364 18.618182 11.636364 30.254545 2.327273 23.272727-16.290909 41.890909-39.563637 41.890909z m0-172.218182h-130.327272c-23.272727 0-44.218182-18.618182-44.218182-41.890909s18.618182-44.218182 44.218182-41.890909h130.327272c23.272727 0 44.218182 18.618182 44.218182 41.890909-2.327273 23.272727-20.945455 41.890909-44.218182 41.890909z"
                    p-id="1043"
                    fill="#2E68EA"
                  />
                </svg>
                <svg
                  v-if="item.url === '/data-import'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="7824"
                  width="18"
                  height="18"
                >
                  <path
                    d="M146.618182 814.545455V162.909091c0-13.963636-9.309091-23.272727-23.272727-23.272727h-46.545455c-13.963636 0-23.272727 9.309091-23.272727 23.272727v698.181818c0 51.2 41.890909 93.090909 93.090909 93.090909h698.181818c13.963636 0 23.272727-9.309091 23.272727-23.272727v-46.545455c0-13.963636-9.309091-23.272727-23.272727-23.272727h-651.636364c-25.6 0-46.545455-20.945455-46.545454-46.545454z"
                    p-id="7825"
                    fill="#2E68EA"
                  />
                  <path
                    d="M239.709091 116.363636v605.090909c0 25.6 20.945455 46.545455 46.545454 46.545455h605.09091c25.6 0 46.545455-20.945455 46.545454-46.545455V116.363636c0-25.6-20.945455-46.545455-46.545454-46.545454h-605.09091c-25.6 0-46.545455 20.945455-46.545454 46.545454z m349.090909 523.636364l-65.163636-65.163636-97.745455-97.745455 65.163636-65.163636 51.2 51.2V197.818182h93.09091v265.309091l53.527272-53.527273 65.163637 65.163636-165.236364 165.236364z"
                    p-id="7826"
                    fill="#2E68EA"
                  />
                </svg>
                <svg
                  v-if="item.url === '/express-rules'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="8731"
                  width="18"
                  height="18"
                >
                  <path
                    d="M635.345455 69.818182h-418.909091c-51.2 0-93.090909 41.890909-93.090909 93.090909v698.181818c0 51.2 41.890909 93.090909 93.090909 93.090909h558.545454c51.2 0 93.090909-41.890909 93.090909-93.090909V302.545455h-162.909091c-39.563636 0-69.818182-30.254545-69.818181-69.818182V69.818182z m-48.872728 728.436363h-302.545454c-25.6 0-46.545455-20.945455-46.545455-46.545454s20.945455-46.545455 46.545455-46.545455h302.545454c25.6 0 46.545455 20.945455 46.545455 46.545455s-20.945455 46.545455-46.545455 46.545454z m0-162.90909h-302.545454c-25.6 0-46.545455-20.945455-46.545455-46.545455s20.945455-46.545455 46.545455-46.545455h302.545454c25.6 0 46.545455 20.945455 46.545455 46.545455s-20.945455 46.545455-46.545455 46.545455z"
                    p-id="8732"
                    fill="#2E68EA"
                  />
                  <path
                    d="M868.072727 256h-116.363636c-39.563636 0-69.818182-30.254545-69.818182-69.818182V69.818182"
                    p-id="8733"
                    fill="#2E68EA"
                  />
                </svg>
              </p>
              <span>
                {{ item.name }}
              </span>
            </div>
          </span>
        </el-menu-item>

        <el-submenu
          :index="item.url"
          v-show="item.children && item.children.length !== 0"
        >
          <template slot="title">
            <div class="menu-title">
              <p class="menu-left">
                <svg
                  v-if="item.url === '/base-info'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="8051"
                  width="18"
                  height="18"
                >
                  <path
                    d="M861.090909 954.181818H162.909091c-51.2 0-93.090909-41.890909-93.090909-93.090909V535.272727h884.363636v325.818182c0 51.2-41.890909 93.090909-93.090909 93.090909zM116.363636 209.454545h791.272728c25.6 0 46.545455 20.945455 46.545454 46.545455v186.181818H69.818182v-186.181818c0-25.6 20.945455-46.545455 46.545454-46.545455zM279.272727 116.363636v93.090909h116.363637V165.236364h232.727272V209.454545h116.363637V116.363636c0-25.6-20.945455-46.545455-46.545455-46.545454H325.818182c-25.6 0-46.545455 20.945455-46.545455 46.545454z"
                    p-id="8052"
                    fill="#2E68EA"
                  />
                </svg>
                <svg
                  v-if="item.url === '/service'"
                  t="1647592918802"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2732"
                  width="18"
                  height="18"
                >
                  <path
                    d="M860.7 349.9c13.3 1.5 26.1 4.9 39.4 10.3s24.6 13.3 33.9 23.1c9.8 9.8 16.7 22.6 21.6 37.9 4.9 15.3 5.4 33 2 54.1v1c-1.5 5.9-3.9 19.2-8.4 40.3-3.9 21.6-8.9 46.7-14.3 74.8-5.4 28-11.8 57.1-18.7 87.1-6.9 30-13.3 55.6-19.7 76.8-3.4 12.3-8.4 25.1-14.8 38.4-6.4 13.3-14.8 25.1-25.1 35.4-10.3 10.8-22.6 19.7-37.4 26.6-14.3 6.9-31.5 10.3-51.7 10.3H196c-14.3 0-29.5-3-44.8-9.3-15.3-6.4-30-14.8-42.8-26.6s-23.6-25.1-32-41.3c-8.4-16.2-12.3-34.4-12.3-54.1V291.8c0-41.8 11.3-74.8 33.9-98.4s54.7-35.4 96-35.4h507.7c15.3 0 31 3 46.7 8.9 16.2 5.9 31 13.8 43.8 24.1 13.3 10.3 23.6 22.1 32 35.9s12.3 28.5 12.3 44.3c0 6.4-4.9 11.3-11.3 11.3H783c-27.6 0-59.5 0-96.4-0.5s-76.3-0.5-117.6-0.5-80.7 0-116.6-0.5c-35.9-0.5-67.4-0.5-93.5-0.5h-47.7c-17.7 0-32 5.9-41.8 17.2-9.8 11.3-17.7 26.6-23.1 44.8-5.4 20.2-11.8 41.3-18.7 63.5s-13.3 43.3-18.7 62.5c-6.9 22.6-13.8 44.3-20.7 65.4 0 0.5 0 0.5-0.5 1-1.5 5.4-2 9.8-2 12.8 0 11.8 3.9 21.6 11.8 29.5 7.9 7.9 17.7 11.8 29.5 11.8 21.2 0 35.9-13.3 43.3-40.3l52.6-191.9c1.5-4.9 5.9-8.4 11.3-8.4 86.1 0.5 164.8 1 237.1 1l289.4 0.5z"
                    p-id="2733"
                    fill="#2e68ea"
                  ></path>
                </svg>
                <svg
                  v-if="item.url === '/attendance'"
                  t="1647592615543"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3683"
                  width="18"
                  height="18"
                >
                  <path
                    d="M118.6816 482.7136v314.368c0 69.3248 56.1664 125.4912 125.4912 125.4912H774.656c69.3248 0 125.4912-56.1664 125.4912-125.4912v-314.368H118.6816zM481.28 635.2896H290.1504c-16.9472 0-30.72-13.7728-30.72-30.72s13.7728-30.72 30.72-30.72H481.28c16.9472 0 30.72 13.7728 30.72 30.72s-13.7728 30.72-30.72 30.72zM303.0016 296.3968c-16.9472 0-30.72-13.7728-30.72-30.72V157.184c0-16.9472 13.7728-30.72 30.72-30.72s30.72 13.7728 30.72 30.72v108.4928c0 16.9984-13.7728 30.72-30.72 30.72zM720.4352 296.3968c-16.9472 0-30.72-13.7728-30.72-30.72V157.184c0-16.9472 13.7728-30.72 30.72-30.72s30.72 13.7728 30.72 30.72v108.4928c0 16.9984-13.7728 30.72-30.72 30.72z"
                    fill="#2e68ea"
                    p-id="3684"
                  ></path>
                  <path
                    d="M784.4352 182.4256v83.2512c0 35.2768-28.7232 64-64 64s-64-28.7232-64-64V182.016H367.0016v83.6608c0 35.2768-28.7232 64-64 64s-64-28.7232-64-64V182.1696c-66.9184 2.7136-120.32 57.8048-120.32 125.3888v112.4352h781.5168V307.5072c0-65.9968-50.9952-120.064-115.7632-125.0816z"
                    fill="#2e68ea"
                    p-id="3685"
                  ></path>
                </svg>
                <svg
                  v-if="item.url === '/project-manage'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="8051"
                  width="18"
                  height="18"
                >
                  <path
                    d="M861.090909 954.181818H162.909091c-51.2 0-93.090909-41.890909-93.090909-93.090909V535.272727h884.363636v325.818182c0 51.2-41.890909 93.090909-93.090909 93.090909zM116.363636 209.454545h791.272728c25.6 0 46.545455 20.945455 46.545454 46.545455v186.181818H69.818182v-186.181818c0-25.6 20.945455-46.545455 46.545454-46.545455zM279.272727 116.363636v93.090909h116.363637V165.236364h232.727272V209.454545h116.363637V116.363636c0-25.6-20.945455-46.545455-46.545455-46.545454H325.818182c-25.6 0-46.545455 20.945455-46.545455 46.545454z"
                    p-id="8052"
                    fill="#2E68EA"
                  />
                </svg>
                <svg
                  v-if="item.url === '/carrier'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="8277"
                  width="18"
                  height="18"
                >
                  <path
                    d="M176.872727 900.654545c-65.163636 0-116.363636-51.2-116.363636-116.363636s51.2-116.363636 116.363636-116.363636 116.363636 51.2 116.363637 116.363636-51.2 116.363636-116.363637 116.363636zM828.509091 900.654545c-65.163636 0-116.363636-51.2-116.363636-116.363636s51.2-116.363636 116.363636-116.363636 116.363636 51.2 116.363636 116.363636-51.2 116.363636-116.363636 116.363636z"
                    p-id="8278"
                    fill="#2E68EA"
                  />
                  <path
                    d="M1003.054545 558.545455H698.181818v235.054545h258.327273c25.6 0 46.545455-20.945455 46.545454-46.545455V558.545455z"
                    p-id="8279"
                    fill="#2E68EA"
                  />
                  <path
                    d="M842.472727 374.690909H698.181818v48.872727h130.327273c13.963636 0 25.6 6.981818 34.909091 18.618182l83.781818 118.690909h55.854545l-128-167.563636c-9.309091-11.636364-20.945455-18.618182-32.581818-18.618182zM698.181818 793.6H46.545455c-25.6 0-46.545455-20.945455-46.545455-46.545455v-558.545454c0-51.2 41.890909-93.090909 93.090909-93.090909h512c51.2 0 93.090909 41.890909 93.090909 93.090909v605.090909z"
                    p-id="8280"
                    fill="#2E68EA"
                  />
                </svg>
                <svg
                  v-if="item.url === '/cost'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="8958"
                  width="18"
                  height="18"
                >
                  <path
                    d="M104.727273 786.618182l344.436363 148.945454c41.890909 18.618182 93.090909 18.618182 134.981819 0l344.436363-148.945454c18.618182-6.981818 27.927273-25.6 27.927273-44.218182 0-18.618182-11.636364-37.236364-27.927273-44.218182l-53.527273-23.272727c-23.272727-9.309091-48.872727-9.309091-72.145454 0l-186.181818 81.454545c-23.272727 9.309091-46.545455 18.618182-72.145455 18.618182-39.563636 4.654545-81.454545-2.327273-118.690909-18.618182L230.4 674.909091c-23.272727-9.309091-48.872727-9.309091-72.145455 0l-53.527272 23.272727c-39.563636 16.290909-39.563636 69.818182 0 88.436364z m0-470.109091L449.163636 465.454545c41.890909 18.618182 93.090909 18.618182 134.981819 0l344.436363-148.945454c18.618182-6.981818 27.927273-25.6 27.927273-44.218182 0-18.618182-11.636364-37.236364-27.927273-44.218182L584.145455 81.454545c-41.890909-18.618182-93.090909-18.618182-134.981819 0L104.727273 228.072727c-39.563636 16.290909-39.563636 72.145455 0 88.436364z m0 0"
                    p-id="8959"
                    fill="#2E68EA"
                  />
                  <path
                    d="M104.727273 549.236364L449.163636 698.181818c41.890909 18.618182 93.090909 18.618182 134.981819 0l344.436363-148.945454c16.290909-6.981818 27.927273-25.6 27.927273-44.218182 0-18.618182-11.636364-34.909091-27.927273-44.218182l-53.527273-23.272727c-23.272727-9.309091-48.872727-9.309091-72.145454 0l-186.181818 81.454545c-23.272727 9.309091-46.545455 18.618182-72.145455 18.618182-39.563636 4.654545-81.454545-2.327273-118.690909-18.618182l-190.836364-81.454545c-23.272727-9.309091-48.872727-9.309091-72.145454 0l-53.527273 23.272727c-18.618182 6.981818-27.927273 25.6-27.927273 44.218182-6.981818 20.945455 4.654545 37.236364 23.272728 44.218182z m0 0"
                    p-id="8960"
                    fill="#2E68EA"
                  />
                </svg>
                <svg
                  v-if="item.url === '/warehouse-manage'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="1134"
                  width="18"
                  height="18"
                >
                  <path
                    d="M202.472727 62.836364H837.818182c23.272727 0 46.545455 16.290909 53.527273 39.563636l72.145454 237.381818h-884.363636l69.818182-237.381818c6.981818-25.6 27.927273-39.563636 53.527272-39.563636z m758.690909 330.472727v498.036364c0 13.963636-6.981818 27.927273-16.290909 39.563636-9.309091 9.309091-23.272727 16.290909-39.563636 16.290909H132.654545c-13.963636 0-27.927273-6.981818-39.563636-16.290909-9.309091-9.309091-16.290909-23.272727-16.290909-39.563636V393.309091h884.363636zM698.181818 614.4H339.781818c-13.963636 0-27.927273 6.981818-34.909091 20.945455-6.981818 13.963636-6.981818 27.927273 0 41.890909 6.981818 13.963636 20.945455 20.945455 34.909091 20.945454H698.181818c13.963636 0 27.927273-6.981818 34.909091-20.945454 6.981818-13.963636 6.981818-27.927273 0-41.890909-4.654545-11.636364-18.618182-20.945455-34.909091-20.945455z m0 0"
                    p-id="1135"
                    fill="#2E68EA"
                  />
                </svg>
                <svg
                  v-if="item.url === '/system-settings'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="1172"
                  width="18"
                  height="18"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <path
                    d="M781.473684 476.968421c-29.642105 0-56.589474 16.168421-70.063158 40.421053s-13.473684 56.589474 0 80.842105c13.473684 24.252632 40.421053 40.421053 70.063158 40.421053 45.810526 0 80.842105-35.031579 80.842105-80.842106 0-43.115789-37.726316-80.842105-80.842105-80.842105z"
                    p-id="1173"
                    fill="#2E68EA"
                  />
                  <path
                    d="M916.210526 0H107.789474C48.505263 0 0 48.505263 0 107.789474v808.421052c0 59.284211 48.505263 107.789474 107.789474 107.789474h808.421052c59.284211 0 107.789474-48.505263 107.789474-107.789474V107.789474c0-59.284211-48.505263-107.789474-107.789474-107.789474zM557.810526 773.389474H97.010526v-21.557895c0-26.947368 18.863158-56.589474 43.11579-67.368421l132.042105-61.978947s8.084211-2.694737 8.084211-16.168422v-18.863157c0-18.863158-48.505263-37.726316-56.589474-97.010527-2.694737-26.947368-5.389474-80.842105-5.389474-86.231579 0-51.2 53.894737-94.315789 110.484211-94.315789 56.589474 0 110.484211 40.421053 110.48421 94.315789 0 2.694737 0 59.284211-5.389473 86.231579-8.084211 59.284211-56.589474 80.842105-56.589474 97.010527v18.863157c0 10.778947 8.084211 16.168421 8.08421 16.168422l132.042106 61.978947c24.252632 10.778947 43.115789 40.421053 43.115789 67.368421v21.557895zM943.157895 590.147368s-37.726316 8.084211-40.421053 13.473685c-2.694737 2.694737-2.694737 8.084211-5.389474 10.778947 5.389474 8.084211 29.642105 24.252632 29.642106 24.252632l-61.978948 64.673684s-24.252632-24.252632-29.642105-26.947369c-5.389474 2.694737-8.084211 2.694737-13.473684 5.389474s-8.084211 37.726316-8.084211 37.726316h-64.673684s-5.389474-37.726316-10.778947-40.421053c-2.694737 0-5.389474-2.694737-10.778948-2.694737-5.389474 2.694737-45.810526 26.947368-45.810526 26.947369l-48.505263-64.673684s21.557895-16.168421 29.642105-26.947369c-2.694737-2.694737-2.694737-8.084211-5.389474-10.778947-5.389474-5.389474-40.421053-13.473684-40.421052-13.473684v-64.673685l40.421052-8.08421c0-2.694737 2.694737-5.389474 2.694737-8.084211-2.694737-8.084211-24.252632-32.336842-24.252631-32.336842l48.505263-64.673684s29.642105 26.947368 37.726316 29.642105c2.694737-2.694737 8.084211-2.694737 10.778947-2.694737 10.778947-2.694737 16.168421-43.115789 16.168421-43.115789h64.673684s10.778947 40.421053 16.168421 40.421053c2.694737 0 8.084211 2.694737 10.778948 2.694736 8.084211-2.694737 37.726316-29.642105 37.726316-29.642105l48.505263 61.978948s-24.252632 18.863158-29.642106 29.642105c0 2.694737 2.694737 5.389474 2.694737 8.08421 0 2.694737 43.115789 10.778947 43.11579 10.778948v72.757894z"
                    p-id="1174"
                    fill="#2E68EA"
                  />
                </svg>
                <svg
                  v-if="item.url === '/finance'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="1529"
                  width="18"
                  height="18"
                >
                  <path
                    d="M959.359 854.226c0 12.485-2.133 24.14-6.404 34.98-4.271 10.84-10.347 20.364-18.227 28.577-7.884 8.214-17.085 14.618-27.595 19.213-10.506 4.6-22.004 6.898-34.488 6.898h-715.38c-12.48 0-24.306-2.298-35.475-6.898-11.164-4.595-21.017-10.999-29.558-19.213-8.543-8.214-15.276-17.738-20.2-28.576-4.93-10.84-7.391-22.497-7.391-34.981V362.523c0-24.96 8.701-46.145 26.11-63.554 17.409-17.408 38.595-26.115 63.559-26.115h715.38c24.964 0 46.15 8.707 63.559 26.115 17.409 17.41 26.11 38.595 26.11 63.554v134.014H735.681c-24.965 0-46.15 8.538-63.56 25.617-17.408 17.08-26.11 38.101-26.11 63.065 0.66 17.08 4.272 32.19 10.841 45.328 5.253 11.17 13.96 21.35 26.11 30.545 12.155 9.196 29.729 13.796 52.719 13.796h223.678v179.338z m-134.01-626.7H377.99c35.474-18.39 68.976-36.127 100.507-53.206a9304.123 9304.123 0 0 0 81.79-43.36c26.932-14.448 47.954-25.617 63.064-33.502 22.99-12.48 43.519-18.23 61.586-17.244 18.062 0.986 33.337 4.106 45.816 9.36 14.454 7.226 26.937 16.75 37.449 28.577l57.148 109.376zM691.34 585.22c0-12.48 4.27-22.99 12.808-31.533 8.544-8.538 19.054-12.808 31.534-12.808 12.479 0 22.99 4.27 31.533 12.808 8.538 8.542 12.808 19.054 12.808 31.533s-4.27 23.155-12.808 32.026c-8.544 8.865-19.054 13.302-31.533 13.302-12.48 0-22.99-4.436-31.534-13.302-8.538-8.871-12.808-19.546-12.808-32.026z m0 0"
                    fill="#2E68EA"
                    p-id="1530"
                  ></path>
                </svg>
                <svg
                  v-if="item.url === '/home'"
                  t="1587365559285"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="7552"
                  width="18"
                  height="18"
                >
                  <path
                    d="M453.818182 88.436364L95.418182 302.545455c-23.272727 13.963636-39.563636 41.890909-39.563637 69.818181v498.036364c0 44.218182 34.909091 81.454545 81.454546 81.454545h230.4v-200.145454c0-23.272727 18.618182-39.563636 39.563636-39.563636h160.581818c23.272727 0 39.563636 18.618182 39.563637 39.563636v200.145454H861.090909c44.218182 0 81.454545-34.909091 81.454546-81.454545V370.036364c0-27.927273-16.290909-55.854545-39.563637-69.818182L535.272727 88.436364c-25.6-13.963636-55.854545-13.963636-81.454545 0z"
                    p-id="7553"
                    fill="#2E68EA"
                  />
                </svg>
                <svg
                  v-if="item.url === '/employee'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="1042"
                  width="18"
                  height="18"
                >
                  <path
                    d="M851.781818 69.818182h-698.181818c-51.2 0-93.090909 41.890909-93.090909 93.090909v698.181818c0 51.2 41.890909 93.090909 93.090909 93.090909h698.181818c51.2 0 93.090909-41.890909 93.090909-93.090909V162.909091c0-51.2-41.890909-93.090909-93.090909-93.090909zM539.927273 737.745455H141.963636v-18.618182c0-23.272727 16.290909-48.872727 37.236364-58.181818l114.036364-53.527273s6.981818-2.327273 6.981818-13.963637v-16.290909c0-16.290909-41.890909-32.581818-48.872727-83.781818-2.327273-23.272727-4.654545-69.818182-4.654546-74.472727 0-44.218182 46.545455-81.454545 95.418182-81.454546 48.872727 0 95.418182 34.909091 95.418182 81.454546 0 2.327273 0 51.2-4.654546 74.472727-6.981818 51.2-48.872727 69.818182-48.872727 83.781818v16.290909c0 9.309091 6.981818 13.963636 6.981818 13.963637l114.036364 53.527273c20.945455 9.309091 37.236364 34.909091 37.236363 58.181818v18.618182z m293.236363 4.654545h-130.327272c-23.272727 0-44.218182-18.618182-44.218182-41.890909s18.618182-44.218182 44.218182-41.890909h130.327272c23.272727 0 44.218182 18.618182 44.218182 41.890909-2.327273 23.272727-20.945455 41.890909-44.218182 41.890909z m0-172.218182h-130.327272c-23.272727 0-44.218182-18.618182-44.218182-41.890909 0-11.636364 4.654545-23.272727 11.636363-30.254545 6.981818-6.981818 18.618182-11.636364 30.254546-11.636364h130.327273c11.636364 0 23.272727 4.654545 30.254545 11.636364 6.981818 6.981818 11.636364 18.618182 11.636364 30.254545 2.327273 23.272727-16.290909 41.890909-39.563637 41.890909z m0-172.218182h-130.327272c-23.272727 0-44.218182-18.618182-44.218182-41.890909s18.618182-44.218182 44.218182-41.890909h130.327272c23.272727 0 44.218182 18.618182 44.218182 41.890909-2.327273 23.272727-20.945455 41.890909-44.218182 41.890909z"
                    p-id="1043"
                    fill="#2E68EA"
                  />
                </svg>
                <svg
                  v-if="item.url === '/data-import'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="7824"
                  width="18"
                  height="18"
                >
                  <path
                    d="M146.618182 814.545455V162.909091c0-13.963636-9.309091-23.272727-23.272727-23.272727h-46.545455c-13.963636 0-23.272727 9.309091-23.272727 23.272727v698.181818c0 51.2 41.890909 93.090909 93.090909 93.090909h698.181818c13.963636 0 23.272727-9.309091 23.272727-23.272727v-46.545455c0-13.963636-9.309091-23.272727-23.272727-23.272727h-651.636364c-25.6 0-46.545455-20.945455-46.545454-46.545454z"
                    p-id="7825"
                    fill="#2E68EA"
                  />
                  <path
                    d="M239.709091 116.363636v605.090909c0 25.6 20.945455 46.545455 46.545454 46.545455h605.09091c25.6 0 46.545455-20.945455 46.545454-46.545455V116.363636c0-25.6-20.945455-46.545455-46.545454-46.545454h-605.09091c-25.6 0-46.545455 20.945455-46.545454 46.545454z m349.090909 523.636364l-65.163636-65.163636-97.745455-97.745455 65.163636-65.163636 51.2 51.2V197.818182h93.09091v265.309091l53.527272-53.527273 65.163637 65.163636-165.236364 165.236364z"
                    p-id="7826"
                    fill="#2E68EA"
                  />
                </svg>
                <svg
                  v-if="item.url === '/express-rules'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="8731"
                  width="18"
                  height="18"
                >
                  <path
                    d="M635.345455 69.818182h-418.909091c-51.2 0-93.090909 41.890909-93.090909 93.090909v698.181818c0 51.2 41.890909 93.090909 93.090909 93.090909h558.545454c51.2 0 93.090909-41.890909 93.090909-93.090909V302.545455h-162.909091c-39.563636 0-69.818182-30.254545-69.818181-69.818182V69.818182z m-48.872728 728.436363h-302.545454c-25.6 0-46.545455-20.945455-46.545455-46.545454s20.945455-46.545455 46.545455-46.545455h302.545454c25.6 0 46.545455 20.945455 46.545455 46.545455s-20.945455 46.545455-46.545455 46.545454z m0-162.90909h-302.545454c-25.6 0-46.545455-20.945455-46.545455-46.545455s20.945455-46.545455 46.545455-46.545455h302.545454c25.6 0 46.545455 20.945455 46.545455 46.545455s-20.945455 46.545455-46.545455 46.545455z"
                    p-id="8732"
                    fill="#2E68EA"
                  />
                  <path
                    d="M868.072727 256h-116.363636c-39.563636 0-69.818182-30.254545-69.818182-69.818182V69.818182"
                    p-id="8733"
                    fill="#2E68EA"
                  />
                </svg>

                <svg
                  v-if="item.url === '/vehicle'"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="8731"
                  width="18"
                  height="18"
                >
                  <path
                    d="M635.345455 69.818182h-418.909091c-51.2 0-93.090909 41.890909-93.090909 93.090909v698.181818c0 51.2 41.890909 93.090909 93.090909 93.090909h558.545454c51.2 0 93.090909-41.890909 93.090909-93.090909V302.545455h-162.909091c-39.563636 0-69.818182-30.254545-69.818181-69.818182V69.818182z m-48.872728 728.436363h-302.545454c-25.6 0-46.545455-20.945455-46.545455-46.545454s20.945455-46.545455 46.545455-46.545455h302.545454c25.6 0 46.545455 20.945455 46.545455 46.545455s-20.945455 46.545455-46.545455 46.545454z m0-162.90909h-302.545454c-25.6 0-46.545455-20.945455-46.545455-46.545455s20.945455-46.545455 46.545455-46.545455h302.545454c25.6 0 46.545455 20.945455 46.545455 46.545455s-20.945455 46.545455-46.545455 46.545455z"
                    p-id="8732"
                    fill="#2E68EA"
                  />
                  <path
                    d="M868.072727 256h-116.363636c-39.563636 0-69.818182-30.254545-69.818182-69.818182V69.818182"
                    p-id="8733"
                    fill="#2E68EA"
                  />
                </svg>
                
              </p>
              <span>
                {{ item.name }}
              </span>
            </div>
          </template>
          <div v-for="(itemChildren, index) in item.children" :key="index">
            <!-- 二级菜单 -->
            <el-menu-item-group
              v-show="
                !itemChildren.children || itemChildren.children.length === 0
              "
            >
              <el-menu-item
                :index="itemChildren.commonUrl"
                :route="{ path: itemChildren.url }"
                >{{ itemChildren.name }}</el-menu-item
              >
            </el-menu-item-group>

            <!-- 三级菜单 -->
            <el-submenu
              :index="itemChildren.commonUrl"
              v-show="
                itemChildren.children && itemChildren.children.length !== 0
              "
            >
              <template slot="title">
                {{ itemChildren.name }}
              </template>
              <el-menu-item-group
                class="thiredChildren-menu-item"
                v-for="(thiredChildren, index) in itemChildren.children"
                :key="index"
              >
                <el-menu-item
                  :index="thiredChildren.commonUrl"
                  :route="{ path: thiredChildren.url }"
                  >{{ thiredChildren.name }}</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
          </div>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
// import { getDBUserRealName } from "common/js/storage";
import UserManage from "models/user-manage";
const userManage = new UserManage();
export default {
  inject: ["reload"],
  computed: {
    activeRouterIndex() {
      let path = this.$route.path.split("/");
      let url = `/${path[1]}/${path[2]}`;
      if (
        url == "/base-info/carrier" ||
        url == "/base-info/project-manage" ||
        url == "/attendance/staffCosts" ||
        url == "/attendance/employee" ||
        url == "/vehicle/homework-center"  || 
        url == "/vehicle/personnel-equipment" ||
        url == "/vehicle/rule-configuration"
      ) {
        let thirdUrl = url + `/${path[3]}`;
        return thirdUrl;
      } else {
        return url;
      }
    },
  },
  data() {
    return {
      allMenuList: [
        {
          name: "数据中心",
          url: "/home",
          keyword: "data_center",
          children: [
            // {
            //   name: "数据发布",
            //   url: "/home/data-state",
            //   keyword: "DATA_CENTER_publish",
            //   commonUrl: "/home/data-state",
            // },
            {
              name: "运营数据",
              url: "/home/operateIndex",
              keyword: "DATA_CENTER_operational_data",
              commonUrl: "/home/operateIndex",
            },
            {
              name: "生产数据",
              url: "/home/production-data/shipment-data",
              keyword: "DATA_CENTER_shipment_data",
              commonUrl: "/home/production-data",
            },
          ],
        },
        {
          name: "数据导入",
          url: "/data-import",
          keyword: "data_upload",
          children: [
            // {
            //   name: "步骤指南",
            //   url: "/data-import/step-guide",
            //   keyword: "DATA_guide",
            //   commonUrl: '/data-import/step-guide',
            // },
            {
              name: "异常修正",
              url: "/data-import/wms-order",
              keyword: "DATA_UPLOAD_anomaly_correction",
              commonUrl: "/data-import/wms-order",
            },
            {
              name: "数据录入",
              url: "/data-import/data-entry/receiving-data",
              keyword: "DATA_UPLOAD_data_import",
              commonUrl: "/data-import/data-entry",
            },
            // {
            //   name: "场地面积录入",
            //   url: "/data-import/rental-income",
            //   keyword: "DATA_rent_income",
            //   commonUrl: "/data-import/rental-income",
            // },
            // {
            //   name: "其他收入",
            //   url: "/data-import/other-income",
            //   keyword: "DATA_other_income",
            //   commonUrl: "/data-import/other-income",
            // },
            /*{ 
              name: "实际快递",
              url: "/data-import/income-expenditure",
              keyword: "DATA_real_express"
            }, */
            // {
            //   name: "相关费用",
            //   url: "/data-import/expenses",
            //   keyword: "DATA_other_fee",
            //   commonUrl: "/data-import/expenses",
            // },
            // {
            //   name: "其他费用",
            //   url: "/data-import/intercept-warehousing",
            //   keyword: "defalut",
            //   commonUrl: "/data-import/intercept-warehousing",
            // },
          ],
        },
        {
          name: "基础信息",
          url: "/base-info",
          keyword: 'base_info',
          children: [
            {
              name: "项目管理",
              url: "/base-info/project-manage",
              keyword: "defalut",
              commonUrl: "/base-info/project-manage",
              children: [
                {
                  name: "客户列表",
                  url: "/base-info/project-manage/customer-list",
                  keyword: "BASE_INFO_customer",
                  commonUrl: "/base-info/project-manage/customer-list",
                },
                {
                  name: "电商仓项目",
                  url: "/base-info/project-manage/project-list/project-manage-list",
                  keyword: "BASE_INFO_project",
                  commonUrl: "/base-info/project-manage/project-list",
                },
                {
                  name: "进出仓项目",
                  url: "/base-info/project-manage/entering-exiting-warehouse/entering-exiting-warehouse-list",
                  keyword: "BASE_INFO_imports_exports_project",
                  commonUrl: "/base-info/project-manage/entering-exiting-warehouse",
                },
              ],
            },
            {
              name: "仓库管理",
              url: "/base-info/warehouse-manage",
              keyword: "BASE_INFO_warehouse",
              commonUrl: "/base-info/warehouse-manage",
            },
            {
              name: "物流维护",
              url: "/base-info/carrier",
              keyword: "defalut",
              commonUrl: "/base-info/carrier",
              children: [
                {
                  name: "物流匹配规则",
                  url: "/base-info/carrier/carrier-archives",
                  keyword: "BASE_INFO_express_order_name",
                  commonUrl: "/base-info/carrier/carrier-archives",
                },
                {
                  name: "客户快递规则",
                  url: "/base-info/carrier/logistics/logistics-list",
                  keyword: "BASE_INFO_customer_express_rules",
                  commonUrl: "/base-info/carrier/logistics",
                },
                {
                  name: "承运商快递规则",
                  url: "/base-info/carrier/express/express-inquiry",
                  keyword: "BASE_INFO_carrier_express_rules",
                  commonUrl: "/base-info/carrier/express",
                },
              ],
            },
            {
              name: "商品信息",
              url: "/base-info/goods-info",
              keyword: "BASE_INFO_goods",
              commonUrl: "/base-info/goods-info",
            },
            {
              name: "成本信息",
              url: "/base-info/cost-info",
              keyword: "defalut",
              commonUrl: "/base-info/cost-info",
            },
            {
              name: "增值服务维护",
              url: "/base-info/add-service-manage",
              keyword: "defalut",
              commonUrl: "/base-info/add-service-manage",
            },
            {
              name: "进出仓应付抬头",
              url: "/base-info/coping-with-header",
              keyword: "defalut",
              commonUrl: "/base-info/coping-with-header",
            },
            {
              name: "进出仓应收抬头",
              url: "/base-info/accounts-receivable-header",
              keyword: "defalut",
              commonUrl: "/base-info/accounts-receivable-header",
            },
            {
              name: "进出仓开票信息",
              url: "/base-info/invoice-info",
              keyword: "defalut",
              commonUrl: "/base-info/invoice-info",
            },
            {
              name: "开票商品或劳务名称",
              url: "/base-info/invoiced-goods-services",
              keyword: "defalut",
              commonUrl: "/base-info/invoiced-goods-services",
            }
          ],
        },
        // {
        //   name: "成本计算",
        //   url: "/cost",
        //   keyword: "cost",
        //   children: [],
        // },
        {
          name: "服务",
          url: "/service",
          keyword: "service",
          children: [
            {
              name: "退货登记",
              url: "/service/return-index/return-register",
              keyword: "SERVICE_refund_registry",
              commonUrl: "/service/return-index",
            },
            {
              name: "收费登记",
              url: "/service/charge-index/charge-register",
              keyword: "SERVICE_charge_record",
              commonUrl: "/service/charge-index",
            },
            {
              name: "索赔登记",
              url: "/service/claim-index/claim-register",
              keyword: "SERVICE_claim_record",
              commonUrl: "/service/claim-index",
            },
            {
              name: "进仓登记",
              url: "/service/enter-warehouse-register-index/enter-warehouse-register-list",
              keyword: "SERVICE_imports_order",
              commonUrl: "/service/enter-warehouse-register-index",
            },
            {
              name: "出仓登记",
              url: "/service/exit-warehouse-register-index/exit-warehouse-register-list",
              keyword: "SERVICE_exports_order",
              commonUrl: "/service/exit-warehouse-register-index",
            },
            {
              name: "存储登记",
              url: "/service/storage-register-index/storage-register-list",
              keyword: "SERVICE_rent_order",
              commonUrl: "/service/storage-register-index",
            },
            {
              name: "应收结算",
              url: "/service/accounts-receivable-settlement-index/accounts-receivable-settlement",
              keyword: "SERVICE_cb_logistics_balance",
              commonUrl: "/service/accounts-receivable-settlement-index",
            },
            {
              name: "应付结算",
              url: "/service/settlement-of-accounts-payable-index/settlement-of-accounts-payable",
              keyword: "SERVICE_cb_logistics_balance",
              commonUrl: "/service/settlement-of-accounts-payable-index",
            }
          ],
        },
        {
          name: "考勤",
          url: "/attendance",
          keyword: "attendance",
          children: [
            {
              name: "员工管理",
              url: "/attendance/employee",
              keyword: "defalut",
              commonUrl: "/attendance/employee",
              children: [
                {
                  name: "组织架构",
                  url: "/attendance/employee/employee-organization/organization",
                  keyword: "ATTENDANCE_organization",
                  commonUrl: "/attendance/employee/employee-organization",
                },
                {
                  name: "薪资管理",
                  url: "/attendance/employee/salary-management",
                  keyword: "ATTENDANCE_salary",
                  commonUrl: "/attendance/employee/salary-management",
                },
                {
                  name: "出勤设置",
                  url: "/attendance/employee/attendance-setting",
                  keyword: "ATTENDANCE_attendance",
                  commonUrl: "/attendance/employee/attendance-setting",
                },
                {
                  name: "加班规则",
                  url: "/attendance/employee/overtime-rules",
                  keyword: "ATTENDANCE_overtime",
                  commonUrl: "/attendance/employee/overtime-rules",
                },
                {
                  name: "临时工打卡",
                  url: "/attendance/employee/temporary-clock",
                  keyword: "ATTENDANCE_temporary_worker_clock",
                  commonUrl: "/attendance/employee/temporary-clock",
                },
              ],
            },
            {
              name: "员工费用",
              url: "/attendance/staffCosts",
              keyword: "defalut",
              commonUrl: "/attendance/staffCosts",
              children: [
                {
                  name: "正式工支出",
                  url: "/attendance/staffCosts/personnel/personnel-pay",
                  keyword: "ATTENDANCE_formal_worker_expenditure",
                  commonUrl: "/attendance/staffCosts/personnel",
                },
                {
                  name: "临时工支出",
                  url: "/attendance/staffCosts/temporary-pay",
                  keyword: "ATTENDANCE_temporary_worker_expenditure",
                  commonUrl: "/attendance/staffCosts/temporary-pay",
                },
              ],
            },
          ],
        },
        {
          name: "财务",
          url: "/finance",
          keyword: "finance",
          children: [
            {
              name: "客户对账",
              url: "/finance/financial-reconciliation/financial-reconciliation-list",
              keyword: "FINANCE_customer_bill_check",
              commonUrl: "/finance/financial-reconciliation",
            },
            {
              name: "承运商对账",
              url: "/finance/carrier-reconciliation/carrier-reconciliation-list",
              keyword: "FINANCE_carrier_bill_check",
              commonUrl: "/finance/carrier-reconciliation",
            },
            {
              name: "进出仓应收对账",
              url: "/finance/inventory-reconciliation/inventory-reconciliation-list",
              keyword: "FINANCE_cb_logisitcs_bill_receivable",
              commonUrl: "/finance/inventory-reconciliation",
            },
            {
              name: "进出仓应收开票",
              url: "/finance/entry-exit-invoicing/entry-exit-invoicing-list",
              keyword: "FINANCE_cb_logistics_invoice_receivable",
              commonUrl: "/finance/entry-exit-invoicing",
            },
            {
              name: "进出仓应付对账",
              url: "/finance/reconciliation-of-accounts-payable/reconciliation-of-accounts-payable-list",
              keyword: "FINANCE_cb_logistics_bill_payable",
              commonUrl: "/finance/reconciliation-of-accounts-payable",
            },
            {
              name: "进出仓利润统计",
              url: "/finance/profit-index/profit",
              keyword: "FINANCE_cb_logistics_profit",
              commonUrl: "/finance/profit-index",
            },
            {
              name: "进出仓应付提交",
              url: "/finance/cope-with-submission/cope-with-submission-list",
              keyword: "FINANCE_cb_logistics_invoice_payable",
              commonUrl: "/finance/cope-with-submission",
            },
            // {
            //   name: "快递费用计算",
            //   url: "/finance/cost-calculation/calculation",
            //   keyword: "EXPRESS_carrier_rule",
            //   commonUrl: '/finance/cost-calculation'
            // },
          ],
        },
        {
          name: "系统设置",
          url: "/system-settings",
          keyword: "system_setting",
          children: [
            {
              name: "用户管理",
              url: "/system-settings/user-manage/user-list",
              keyword: "SYSTEM_SETTING_manager",
              commonUrl: "/system-settings/user-manage",
            },
            {
              name: "易仓储推送配置",
              url: "/system-settings/push-configuration-index/push-configuration",
              keyword: "SYSTEM_SETTING_ECC_operator_manage",
              commonUrl: "/system-settings/push-configuration-index",
            },
            {
              name: "部门分配",
              url: "/system-settings/department-allocation-index/department-allocation",
              keyword: "SYSTEM_SETTING_ECC_department_manage",
              commonUrl: "/system-settings/department-allocation-index",
            }
          ],
        },
        {
          name: "智能验车",
          url: "/vehicle",
          keyword: "vehicle_inspect",
          children: [
            {
              name: "作业中心",
              url: "/vehicle/homework-center",
              keyword: "defalut",
              commonUrl: "/vehicle/homework-center",
              children: [
                {
                  name: "采集看板",
                  url: "/vehicle/homework-center/kanban/kanban-list",
                  keyword: "VEHICLE_INSPECT_batch_record",
                  commonUrl: "/vehicle/homework-center/kanban",
                },
                {
                  name: "车辆影像档案",
                  url: "/vehicle/homework-center/archive/car-archive",
                  keyword: "VEHICLE_INSPECT_record",
                  commonUrl: "/vehicle/homework-center/archive",
                },
                {
                  name: "批次管理",
                  url: "/vehicle/homework-center/batch/batch-list",
                  keyword: "VEHICLE_INSPECT_batch_init",
                  commonUrl: "/vehicle/homework-center/batch",
                },
              ],
            },
            {
              name: "人员与设备",
              url: "/vehicle/personnel-equipment",
              keyword: "defalut",
              commonUrl: "/vehicle/personnel-equipment",
              children: [
                {
                  name: "采集人员",
                  url: "/vehicle/personnel-equipment/collect",
                  keyword: "VEHICLE_INSPECT_collector",
                  commonUrl: "/vehicle/personnel-equipment/collect",
                }
              ],
            },
            {
              name: "规则配置",
              url: "/vehicle/rule-configuration",
              keyword: "defalut",
              commonUrl: "/vehicle/rule-configuration",
              children: [
                {
                  name: "品牌维护",
                  url: "/vehicle/rule-configuration/brand",
                  keyword: "VEHICLE_INSPECT_brand",
                  commonUrl: "/vehicle/rule-configuration/brand",
                },
                {
                  name: "采集模板",
                  url: "/vehicle/rule-configuration/collection-template",
                  keyword: "VEHICLE_INSPECT_template",
                  commonUrl: "/vehicle/rule-configuration/collection-template",
                }
              ],
            },
          ],
        }
      ],
      menuList: [],
      activeIndex: "",
      defaultOpenedList: [],
    };
  },
  created() {
    this.managerMenu();
    // let username = getDBUserRealName();
    // if (username === "chenlijun") {
    //   this.menuList = [
    //     {
    //       name: "数据导入",
    //       url: "/data-import",
    //       children: [
    //         {
    //           name: "临时工支出",
    //           url: "/data-import/temporary-pay"
    //         }
    //       ]
    //     }
    //   ];
    //   this.$router.replace({
    //     path: "/data-import/temporary-pay"
    //   });
    // }
    // let url = this.$route.matched[1].path;
    // this.menuList.map((value, index) => {
    //   if (value.url === url) {
    //     if (value.children.length > 0) {
    //       this.activeIndex = index;
    //     }
    //   }
    // });
  },
  methods: {
    //获取当前用户的权限
    managerMenu() {
      userManage.getManagerMenu().then((res) => {
        if (res.success) {
          let moduleKeywordList = res.result.moduleKeywordList;
          let authorityKeywordList = res.result.authorityKeywordList;
          let menuList = [];
          this.allMenuList.map((value) => {
            if (
              moduleKeywordList.indexOf(value.keyword) !== -1 ||
              value.keyword === "defalut"
            ) {
              let obj = {};
              obj.name = value.name;
              obj.url = value.url;
              obj.keyword = value.keyword;
              obj.children = [];
              value.children.map((child) => {
                if (
                  authorityKeywordList.indexOf(child.keyword) !== -1
                  || child.keyword === "defalut"
                ) {
                  let twoChild = {};
                  twoChild.name = child.name;
                  twoChild.url = child.url;
                  twoChild.keyword = child.keyword;
                  twoChild.commonUrl = child.commonUrl;
                  // obj.children.push({
                  //   name: child.name,
                  //   url: child.url,
                  //   keyword: child.keyword,
                  // });
                  if (child.children != undefined) {
                    twoChild.children = [];
                    child.children.map((thirdChild) => {
                      if (
                        authorityKeywordList.indexOf(thirdChild.keyword) !==
                          -1 ||
                        thirdChild.keyword === "defalut"
                      ) {
                        twoChild.children.push({
                          name: thirdChild.name,
                          url: thirdChild.url,
                          keyword: thirdChild.keyword,
                          commonUrl: thirdChild.commonUrl,
                        });
                      }
                    });
                  }
                  if ((twoChild.children!= undefined && twoChild.children.length !== 0) || twoChild.children == undefined) {
                    obj.children.push(twoChild);
                  }
                }
              });
              menuList.push(obj);
            }
          });
          this.menuList = menuList;
          let url = this.$route.matched[1].path;
          let stop = false;
          this.menuList.map((value, index) => {
            if (value.url === url) {
              stop = true;
              if (value.children.length > 0) {
                this.activeIndex = index;
                if (this.$route.matched[2].path) {
                  // console.log(this.$route.matched);
                } else {
                  this.$router.replace({
                    path: value.children[0].url,
                  });
                }
              }
            }
          });
          if (!stop) {
            this.activeIndex = 0;
            if (this.menuList[0].children.length > 0) {
              this.$router.replace({
                path: this.menuList[0].children[0].url,
              });
            } else {
              this.$router.replace({
                path: this.menuList[0].url,
              });
            }
          }
        }
      });
    },
    openMenu(index) {
      let url = index;
      let arr = index.split("/");
      if (arr.length === 2) {
        this.defaultOpenedList = [url];
      } else {
        this.defaultOpenedList[1] = url;
      }
    },
    selectMenu(index) {
      if (index == "/home/operateIndex") {
        this.reload();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.page-menu {
  min-height: 100%;
}
</style>
<style lang="scss">
.page-menu {
  .menuDome {
    .el-menu {
      background: transparent;
      border-right: none;
      .el-menu--inline {
        .el-submenu__title {
          padding-left: 48px !important;
        }
        .el-menu-item.is-active {
          background: #eaf0fd !important;
          border-right: 3px solid #2e68ea !important;
        }
      }
      .el-submenu {
        .el-submenu__title {
          .el-icon-arrow-down:before {
            color: #d9d9d9;
            content: "\E791";
          }
        }
      }
      .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
        transform: rotateZ(-90deg);
      }
      .el-menu-item-group {
        .el-menu-item {
          padding-left: 48px !important;
        }
      }
      .thiredChildren-menu-item {
        .el-menu-item {
          padding-left: 62px !important;
        }
      }
      .el-menu-item-group__title {
        padding: 0;
      }
    }
    .menu-title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .menu-left {
        margin-right: 10px;
      }
    }
  }
}
</style>
